<template>
  <div class="bb-breakdown-column"
  >
    <template v-if="editSoaIndex === index && disableBreakdownAndIncoming">
      <div class="bb-breakdown-column__item"
      >
        <span v-if="services">
          {{convertNumber(soa.breakdown) || 0}}
        </span>
        <input class="bb-table-body__input bb-input bb-input_border bb-input_border_transparent"
               :class="{'bb-input_error' : error}"
               v-else
               @input="changeInput('breakdown', modelBreakDown)"
               @focus="focusInput('breakdown')"
               @keyup.enter="editSoa"
               @keyup.esc="hideEditSoa"
               v-model="modelBreakDown">
        <i class="icon-info bb-breakdown-column__hint"
           @mouseenter="showPopup = includesText"
           @mouseleave="hidePopup()"
        />
      </div>
      <div class="bb-breakdown-column__item">
        <input class="bb-table-body__input bb-input bb-input_border bb-input_border_transparent"
               :class="{'bb-input_error' : error}"
               @input="changeInput('extra', modelExtra)"
               @focus="focusInput('extra')"
               @keyup.enter="editSoa"
               @keyup.esc="hideEditSoa"
               v-model="modelExtra">
        <i class="icon-info bb-breakdown-column__hint"
           @mouseenter="showPopup = notIncludesText"
           @mouseleave="hidePopup()"
        />
      </div>
      <transition name="bounce">
        <div v-if="showPopup"
             class="bb-breakdown-column-popup"
             :class="{'bb-breakdown-column-popup_top': showPopup === notIncludesText}"
        >
          <span class="bb-table-header-popup__title">{{showPopup}}</span>
        </div>
      </transition>
    </template>
    <template v-else>
      <div class="bb-breakdown-column">
        <div class="bb-breakdown-column__item">
          <span>{{convertNumber(soa.breakdown) || 0}}</span>
          <i class="icon-info bb-breakdown-column__hint"
             @mouseenter="showPopup = includesText"
             @mouseleave="hidePopup()"
          />
        </div>
        <div class="bb-breakdown-column__item"
        >
          <span class="bb-breakdown-column__breakdown"
          >
            {{convertNumber(soa.outgoing - soa.breakdown) || 0}}
          </span>
          <i class="icon-info bb-breakdown-column__hint"
             v-if="soa.breakdown"
             @mouseenter="showPopup = notIncludesText"
             @mouseleave="hidePopup()"
          />
        </div>
        <transition name="bounce">
          <div v-if="showPopup"
               class="bb-breakdown-column-popup"
               :class="{'bb-breakdown-column-popup_top': showPopup === notIncludesText}"
          >
            <span class="bb-table-header-popup__title">{{showPopup}}</span>
          </div>
        </transition>
      </div>
    </template>
  </div>
</template>

<script>
import convertNumber from '@/mixin/convertNumber'
import _ from 'lodash'
export default {
  name: 'BreakdownColumn',
  mixins: [convertNumber],
  props: [
    'error',
    'editSoaIndex',
    'index',
    'soa',
    'newSoa',
    'creatingSoa',
    'notNewSoa',
    'breakdownModel',
    'disableInput',
    'extraModel',
    'includesText',
    'notIncludesText'
  ],
  computed: {
    disableBreakdownAndIncoming () {
      return !this.soa.isAutoSoa && !this.soa.isCreditNote
    },
    services () {
      const services = _.get(this.soa, 'invoiceService', [])
      return services.length
    }
  },
  data () {
    return {
      showPopup: false,
      popupPosition: {
        left: 20 + 'px',
        top: 0
      },
      openInput: false,
      modelExtra: this.extraModel,
      modelBreakDown: this.breakdownModel
    }
  },
  methods: {
    changeInput (type, value) {
      this.$emit('changeInput', type, value)
    },
    focusInput (type) {
      this.$emit('focusInput', type)
    },
    hideEditSoa () {
      this.$emit('hideEditSoa')
    },
    editSoa () {
      this.$emit('editSoa')
    },
    hidePopup () {
      this.showPopup = false
    },
    openInputExtra () {
      if (this.soa.isAutoSoa || this.soa.isCreditNote) return
      if (this.newSoa || this.notNewSoa) this.openInput = true
    }
  },
  watch: {
    breakdownModel () {
      this.modelBreakDown = this.breakdownModel
    },
    extraModel () {
      if (this.creatingSoa) return
      this.modelExtra = this.extraModel
      if (this.modelExtra > this.soa.outgoing) this.modelExtra = this.soa.outgoing
      const services = _.get(this.soa, 'invoiceService', [])
      if (services.length > 0) {
        const result = this.soa.outgoing - this.modelExtra
        if (!this.notNewSoa && !this.newSoa) return
        this.$set(this.soa, 'breakdown', result)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
  .bb-breakdown-column {
    @include global-font;
    position: relative;
    display: grid;
    align-items: center;
    justify-content: space-between;
    grid-template-columns: 1fr;
    grid-gap: 10px;

    &-popup {
      position: absolute;
      left: 90%;
      top: -40px;
      padding: 12px 12px;
      background-color: $color-white;
      color: $color-accent;
      list-style: disc inside;
      pointer-events: none;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      white-space: nowrap;
      box-shadow: 0 0 20px rgba($color-black, 0.1);
      border-radius: 5px;
      z-index: 12;

      &_top {
        top: -5px;
      }

      &:after {
        content: '';
        position: absolute;
        left: 10px;
        top: 100%;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-top: 5px solid $color-white;
        box-shadow: 0 0 20px rgba($color-black, 0.1);
      }
    }

    &__item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__breakdown {
      cursor: pointer;
    }

    &__hint {
      position: absolute;
      font-size: 10px;
      color: $color-accent;
      top: 5px;
      right: -10px;
      cursor: pointer;

      &_number {
        top: auto;
      }
    }

    input {
      margin: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/BreakdownColumn.vue